import { Lock } from "lucide-react";

export default function Footer({ onAdmin }) {
  return (
    <footer className="border-t border-gold/15 bg-burgundy-deep py-14 text-cream" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-4 sm:px-8 md:flex-row lg:px-16">
        <div className="max-w-sm">
          <div className="flex items-center gap-2">
            <img src="/logo.jpg" alt="Logo La Table de Saint-François" className="h-12 w-12 rounded-full shadow ring-1 ring-cream/20" />
            <p className="font-serif text-xl font-bold">
              La Table <span className="italic text-gold-light">de Saint-François</span>
            </p>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-cream/60">
            Brasserie pédagogique : les plats et le service sont réalisés par nos élèves
            en formation, sous l'œil attentif de leurs professeurs. Merci de faire
            partie de leur apprentissage.
          </p>
        </div>
        <div className="text-sm text-cream/70">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Services</p>
          <p className="mt-3">Jeudi &amp; Vendredi · 12h00 – 13h15</p>
          <p className="mt-3 text-cream/50">Menu unique — 5 € profs &amp; élèves · 7 € externes</p>
        </div>
        <div className="text-sm">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Équipe</p>
          <button
            onClick={onAdmin}
            className="mt-3 flex items-center gap-2 rounded-full border border-cream/25 px-5 py-2.5 text-xs font-semibold text-cream/80 transition-colors hover:border-gold hover:text-gold-light"
            data-testid="footer-admin-button"
          >
            <Lock className="h-3.5 w-3.5" />
            Espace employés
          </button>
        </div>
      </div>
      <p className="mx-auto mt-12 max-w-7xl px-4 text-xs text-cream/40 sm:px-8 lg:px-16">
        © {new Date().getFullYear()} La Table de Saint-François — Brasserie pédagogique. Tous droits réservés.
      </p>
      <p className="mx-auto mt-2 max-w-7xl px-4 text-xs text-cream/40 sm:px-8 lg:px-16" data-testid="footer-copyright-telmo">
        Site créé par <span className="font-semibold text-cream/60">Telmo</span> — œuvre protégée par le droit d'auteur.
        Toute reproduction, copie ou réutilisation, même partielle, est interdite sans autorisation écrite de son créateur.
      </p>
    </footer>
  );
}
